import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '../../services/common/title.service';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'home',
    template: require('./../../templates/common/forbiddenView.component.html'),
    providers: [TitleService, TranslationService]
})
export class ForbiddenViewComponent {
    forbiddenPageTitle: string;
    forbiddenDescription : string;

    constructor(private titleService: TitleService, private route: ActivatedRoute, private router: Router, private translationService: TranslationService) {
        if (this.router.url != '/page-not-found') {
            this.router.navigate(['/page-not-found']);
        }
    }

    ngOnInit() {
        this.titleService.setTitle(this.route.snapshot.data['title']);

        this.initTranslations();
    }

    initTranslations() {
        this.translationService.translate('forbidden.pageTitle', 'Page not found', (data) => this.forbiddenPageTitle = data);
        this.translationService.translate('forbidden.description', 'Page does not exist or you have no permission for access', (data) => this.forbiddenDescription = data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/common/forbiddenView.component.ts